export default "__VITE_PUBLIC_ASSET__f423ef21__"